/* Author name -> Shopify vendor page (lists that author's books).
   Works for .mi-shop__authorlink spans nested INSIDE a card <a> link:
   preventDefault cancels the card's navigation, then we go to the vendor page. */
(function () {
  function go(el) {
    var v = el.getAttribute('data-vendor');
    if (v) window.location.href = '/collections/vendors?q=' + encodeURIComponent(v);
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('.mi-shop__authorlink');
    if (el) { e.preventDefault(); e.stopPropagation(); go(el); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('.mi-shop__authorlink');
    if (el) { e.preventDefault(); e.stopPropagation(); go(el); }
  });
})();
